/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Donate_Confirm_TitleInputs */

const en_dialog_donate_confirm_title = /** @type {(inputs: Dialog_Donate_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm Contribution`)
};

const ar_dialog_donate_confirm_title = /** @type {(inputs: Dialog_Donate_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تأكيد المساهمة`)
};

const de_dialog_donate_confirm_title = /** @type {(inputs: Dialog_Donate_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beitrag bestätigen`)
};

const es_dialog_donate_confirm_title = /** @type {(inputs: Dialog_Donate_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar contribución`)
};

const fr_dialog_donate_confirm_title = /** @type {(inputs: Dialog_Donate_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmer ma contribution`)
};

const it_dialog_donate_confirm_title = /** @type {(inputs: Dialog_Donate_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conferma contributo`)
};

const ja_dialog_donate_confirm_title = /** @type {(inputs: Dialog_Donate_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`貢献の確認`)
};

const ko_dialog_donate_confirm_title = /** @type {(inputs: Dialog_Donate_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기부 확인`)
};

const pt_br_dialog_donate_confirm_title = /** @type {(inputs: Dialog_Donate_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar contribuição`)
};

const ru_dialog_donate_confirm_title = /** @type {(inputs: Dialog_Donate_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подтвердить вклад`)
};

const th_dialog_donate_confirm_title = /** @type {(inputs: Dialog_Donate_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยืนยันการมีส่วนร่วม`)
};

const tr_dialog_donate_confirm_title = /** @type {(inputs: Dialog_Donate_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katılımı Onayla`)
};

const zh_cn_dialog_donate_confirm_title = /** @type {(inputs: Dialog_Donate_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确认捐献`)
};

const zh_tw_dialog_donate_confirm_title = /** @type {(inputs: Dialog_Donate_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確認捐獻`)
};

/**
* | output |
* | --- |
* | "Confirm Contribution" |
*
* @param {Dialog_Donate_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_donate_confirm_title = /** @type {((inputs?: Dialog_Donate_Confirm_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Donate_Confirm_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_donate_confirm_title(inputs)
	if (locale === "ar") return ar_dialog_donate_confirm_title(inputs)
	if (locale === "de") return de_dialog_donate_confirm_title(inputs)
	if (locale === "es") return es_dialog_donate_confirm_title(inputs)
	if (locale === "fr") return fr_dialog_donate_confirm_title(inputs)
	if (locale === "it") return it_dialog_donate_confirm_title(inputs)
	if (locale === "ja") return ja_dialog_donate_confirm_title(inputs)
	if (locale === "ko") return ko_dialog_donate_confirm_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_donate_confirm_title(inputs)
	if (locale === "ru") return ru_dialog_donate_confirm_title(inputs)
	if (locale === "th") return th_dialog_donate_confirm_title(inputs)
	if (locale === "tr") return tr_dialog_donate_confirm_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_donate_confirm_title(inputs)
	return zh_tw_dialog_donate_confirm_title(inputs)
});